module.exports = __webpack_public_path__ + "img/animals_chicken.8d07668b.png";